const bulkPopup = () => {
    const corporate_btn = document.querySelector(".desktop-pdp-custom-corprate-button"),
        bulk_form_state = document.querySelector('.bulk-form-state');

    if (bulk_form_state) {
        const bulkpopupContainer = document.querySelector(".popup_bulk_container"),
            close_up_btn = document.querySelector(".bulk_close_popup"),
            bulkcloseIconBtn = document.querySelector(".bulk_close_btn"),
            bulknotifySend = bulk_form_state.querySelector('#bulksendButton'),
            bulkProductForm = bulk_form_state.querySelector('#ContactForm-bulkForm');
        bulkthankYouMessage = document.getElementById('bulk_thank_you'),
            fields = bulk_form_state.querySelectorAll('input,textarea');;

        if (corporate_btn) {
            corporate_btn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.add('active');
                document.body.classList.add('overlay_bulkpopup');
            });
        }

        if (close_up_btn) {
            close_up_btn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.remove('active');
                document.body.classList.remove('overlay_bulkpopup');
            });
        }

        if (bulkcloseIconBtn) {
            bulkcloseIconBtn.addEventListener("click", function (event) {
                event.preventDefault();
                bulkpopupContainer.classList.remove("active");
                document.body.classList.remove("overlay_bulkpopup");
                bulkProductForm.submit();
            });
        }

        fields.forEach(field => {
            field.addEventListener('blur', validateField);
        });

        function validateField(event) {
            const field = event.target;
            const errorSpan = field.closest('.field').querySelector('.form-err-msg');
            var errorMessage = '';
            switch (field.name) {
                case 'contact[Full Name]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Name field is required';
                    }
                    break;
                case 'contact[email]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Email field is required';
                    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
                        errorMessage = 'Invalid email address';
                    }
                    break;
                case 'contact[Phone Number]':
                    if (field.value.trim() === '') {
                        errorMessage = 'phone field is required';
                    }
                    else if (!/^\d{10}$/.test(field.value)) {
                        errorMessage = 'Phone number must be 10 digits';
                    }
                    break;
                case 'contact[pincode]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Pincode field is required';
                    }
                    break;
                case 'contact[Product Required]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Product name field is required';
                    }
                    break;
                case 'contact[Quantity Required]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Quantity field is required';
                    }
                    else if (field.value < 5) {
                        errorMessage = 'Value must be greater than or equal to 5.';
                    }
                    break;
                case 'contact[Reason]':
                    if (field.value.trim() === '') {
                        errorMessage = 'Reason field is required';
                    }
                    break;
                default:
                    console.log('Default case');
                    break;
            }
            if (errorSpan.textContent != null) {
                errorSpan.textContent = errorMessage;
            }
        }

        bulknotifySend.addEventListener('click', function (event) {
            event.preventDefault();
            const username = bulk_form_state.querySelector('[name="contact[Full Name]"]').value,
                fromEmail = bulk_form_state.querySelector('[name="contact[From Email ID]"]').value,
                mobile_number = bulk_form_state.querySelector('[name="contact[Phone Number]"]').value,
                email = bulk_form_state.querySelector('[name="contact[email]"]').value,
                pincode = bulk_form_state.querySelector('[name="contact[pincode]"]').value,
                productRequired = bulk_form_state.querySelector('[name="contact[Product Required]"]').value,
                qtyRequired = bulk_form_state.querySelector('[name="contact[Quantity Required]"]').value,
                targetPrice = bulk_form_state.querySelector('[name="contact[Targeted Price]"]').value,
                tentative = bulk_form_state.querySelector('[name="contact[Tentative Timeline]"]').value,
                reason = bulk_form_state.querySelector('[name="contact[Reason]"]').value;

            if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '' || pincode.trim() === '' || productRequired.trim() === '' || qtyRequired.trim() === '' || reason.trim() === '') {
                alert('Please fill out all fields');
                return false;
            }
            const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
            if (!emailPattern.test(email)) {
                alert('Please enter a valid email address');
                return false;
            }

            const mobilePattern = /^\d{10}$/;
            if (!mobilePattern.test(mobile_number)) {
                alert('Please enter a valid 10-digit mobile number');
                return false;
            }

            if (qtyRequired < 5) {
                alert('Value must be greater than or equal to 5.');
                return false;
            }

            bulknotifySend.classList.add('loading');
            fetch('https://cpanel.mensabrands.com/BulkOrder/public/addData', {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-type": "application/json",
                    "Authorization": `Bearer ${window.sessionToken}`
                },
                body: JSON.stringify({
                    full_name: username,
                    email: email,
                    phone_number: mobile_number,
                    pincode: pincode,
                    product_required: productRequired,
                    quantity_required: qtyRequired,
                    targeted_price: targetPrice,
                    tentative_timelines: tentative,
                    reason: reason,
                    fromEmail: fromEmail
                })
            })
                .then(res => {
                    setTimeout(() => {
                        bulkProductForm.submit();
                    }, 5000);
                    bulkthankYouMessage.style.display = 'block';
                    if (close_up_btn) {
                        close_up_btn.style.display = 'none';
                    }
                    bulknotifySend.classList.remove('loading');
                    const parent = bulk_form_state.parentElement;
                    if (parent.classList.contains('popup-scroller')) {
                        parent.style.display = 'none';
                    }
                    else {
                        bulk_form_state.style.display = 'none';
                    }
                })
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    bulkPopup();    
});